import { orderDataSource } from '~/api/data-source/order';
import type { OrderDataSource } from '~/api/data-source/order';
import type { OrderDetail, OrderHistoryPage } from '~/api/model';
import {
  orderDetailSchema,
  orderHistoryPageSchema,
  parseModel,
} from '~/api/model';

export interface OrderRepository {
  getOrderHistories(params?: {
    lastOrderId?: number;
    size?: number;
  }): Promise<OrderHistoryPage>;
  getOrderDetail(orderId: number): Promise<OrderDetail>;
}

export class OrderRepositoryImpl implements OrderRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly dataSource: OrderDataSource = orderDataSource) {}

  async getOrderHistories(params?: { lastOrderId?: number; size?: number }) {
    const response = await this.dataSource.getOrderHistories(params);
    return parseModel(orderHistoryPageSchema, response, 'OrderHistoryPage');
  }

  async getOrderDetail(orderId: number) {
    const response = await this.dataSource.getOrderDetail(orderId);
    return parseModel(orderDetailSchema, response, 'OrderDetail');
  }
}

export const orderRepository = new OrderRepositoryImpl();
